import { endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const createAdminRole = (_, params) => {
  return Api(endPoints.createAdminRole, params, requestType.POST);
};

const getAllAdminRole = () => {
  return Api(endPoints.getAllAdminRole, null, requestType.GET);
};

const getAdminRoleDetail = (id) => {
  return Api(`${endPoints.getAdminRoleDetail}/${id}`, null, requestType.GET);
};

const updateAdminRole = (id, params) => {
  return Api(`${endPoints.updateAdminRole}/${id}`, params, requestType.PUT);
};

const deleteAdminRole = (id) => {
  return Api(`${endPoints.deleteAdminRole}/${id}`, null, requestType.DELETE);
};

export {
  createAdminRole,
  getAllAdminRole,
  getAdminRoleDetail,
  updateAdminRole,
  deleteAdminRole,
};
